import { all, fork } from 'redux-saga/effects';
import watchUser from './services/user/saga';
import watchCompany from './services/company/saga';
import watchChat from './services/chat/saga';
import 'babel-polyfill';

export default function* root() {
  yield all([
    fork(watchUser),
    fork(watchCompany),
    fork(watchChat),
  ]);
}



// WEBPACK FOOTER //
// ./src/rootSaga.js